(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-customization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-cover-picker')) {
    customElements.define('gift-cover-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('change', (event) => {
          const input = event.target;
          if (!input.matches('input[data-media-id]') || !input.checked) return;
          const gallery = document.getElementById(`MediaGallery-${this.dataset.sectionId}`);
          gallery?.setActiveMedia(input.dataset.mediaId, false);
        });
      }
    });
  }

  if (!customElements.get('gift-customization')) {
    customElements.define('gift-customization', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const fates = this.querySelector('[data-gift-fates]');
        const groups = [...this.querySelectorAll('.gift-group')];
        const sync = () => {
          let selectedCount = 0;
          for (const group of groups) {
            const value = group.querySelector('[data-gift-choice]:checked')?.value || 'Random';
            group.querySelector('[data-gift-property]').value = value;
            if (value !== 'Random') selectedCount++;
          }
          fates.checked = selectedCount === 0;
          this.querySelector('[data-gift-mode]').value =
            selectedCount === 0 ? 'All random' : selectedCount === groups.length ? 'Fully selected' : 'Partially selected';
        };
        this.addEventListener('change', (event) => {
          if (event.target === fates && fates.checked) {
            this.querySelectorAll('[data-gift-choice]').forEach(input => { input.checked = false; });
          }
          if (event.target.matches('[data-gift-choice]') || event.target === fates && fates.checked) sync();
        });
        sync();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
